import React from "react";
import { StyleSheet, View, type ViewStyle } from "react-native";

import ScreenLoadingIcon from "../../Icons/Loading/ScreenLoadingIcon";

type ScreenLayoutProps = {
  isLoading: boolean;
  children: React.ReactNode;
  customStyle?: ViewStyle;
};

function ScreenLayout({
  isLoading,
  customStyle,
  children,
}: ScreenLayoutProps): React.JSX.Element {
  return (
    <View style={[styles.container, customStyle]}>
      {isLoading ? <ScreenLoadingIcon /> : children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
    flex: 1,
  },
});

export default ScreenLayout;
